import React, { Component } from "react";
import moment from "moment"; 
import { firebaseDatabase, firebaseApp } from "./../../services/firebaseService";
import { currentUser } from "./../../firebase/firebaseActions";
import { ToggleChat } from "./actions";
import AuthHelper from "./../../services/authService";
import { connect } from "./../../../base/redux";
import MessageAlert from './../Widgets/MessageAlert';
import Chat from "./../../services/Chat"
import { UploadFiles } from "./../Call/call_actions";
import Loader from "../Widgets/Loader"; 
import PreviewModal from "./PreviewModal";

class FireChat extends Component {
    constructor(props) {
        super(props);
        this.state = {previewModal:false,isScreenShot:false,_FilePath: '', chat: [], message: "", selectedFile: "", firebaseParticipants: [], isPrivate: false, chatWith: "public", chatFrom: "", __alertMessage: [], __initiated: false, type: "",previewImage:"" };
    }

    componentDidMount() {
        this.__InitiateChat();
        this.messagesEnd.scrollIntoView({ behavior: "smooth" }); // scroll to bottom
    }

    __InitiateChat = () => {
        let { uniquecode, firstname, lastname, email, app_picture: profile, phone, user_extension, customerID } = AuthHelper.getUserDetail();
        const { meeting_details: { is_owner, topic: displayName, uniquekey } } = this.props;
        let owner = is_owner === customerID;
        let __GrpExists = Chat.fetch_if_ref_exists(`/Groups/${uniquekey}/`, true);
        uniquecode = uniquecode ?? currentUser();
        __GrpExists.then(response => {
            if (Object.keys(response).length === 0) {
                let participants;
                if (user_extension) {
                    participants = [{ id: APP.conference.getMyUserId(), name: `${firstname} ${lastname}`, extension: user_extension, phone, profile, email, uniquecode, owner, type: owner ? "host" : "member", online: true }];
                } else {
                    participants = [{ id: APP.conference.getMyUserId(), name: `${firstname} ${lastname}`, email, uniquecode, type: "guest", online: true }]
                }
                let joinee = [uniquecode];
                Chat.update_ref_with_children(`/Groups/${uniquekey}/`, { createdBy: uniquecode, displayName, profile: "", participants, last_message: "", last_message_sender: "", last_message_type: "", roomName: uniquekey, type: "meet", updated_at: firebaseApp.database.ServerValue.TIMESTAMP, joinee,meet:true }).then(() => {
                    let updateParticipants = participants.map(value => {
                        if (value.uniquecode === uniquecode) {
                            value["online"] = false;
                            return value
                        }
                        return value;
                    })
                    firebaseDatabase.ref(`Groups/${uniquekey}/participants/`).onDisconnect().update(updateParticipants);
                    Chat.fetch_ref_on_update(`/Groups/${uniquekey}`, this.FetchGroupData);
                    this.FetchMessageData();
                });
            } else {
                let joinee = response.joinee ?? [];
                let participants = response.participants;
                let Index = participants ? participants.findIndex(val => val.uniquecode === uniquecode) : -1;
                if (user_extension) {
                    if (Index>=0) {
                        participants[Index] = { ...participants[Index], id: APP.conference.getMyUserId(), profile, online: true }
                    } else {
                        participants = [...participants, { id: APP.conference.getMyUserId(), name: `${firstname} ${lastname}`, extension: user_extension, phone, profile, email, uniquecode, owner, type: owner ? "host" : "member", online: true }];
                    }
                    joinee = joinee.includes(uniquecode) ? joinee : [...joinee, uniquecode];
                } else {
                    if (Index>=0) {
                        participants[Index] = { ...participants[Index], id: APP.conference.getMyUserId(), online: true }
                    } else {
                        participants = [...participants, { id: APP.conference.getMyUserId(), name: `${firstname} ${lastname}`, email, uniquecode, type: "guest", online: true }];
                    }
                    joinee = joinee.includes(uniquecode) ? joinee : [...joinee, uniquecode];
                }
                Chat.update_ref_with_children(`/Groups/${uniquekey}/`, { ...response, joinee, participants }).then(() => {
                    let updateParticipants = participants.map(value => {
                        if (value.uniquecode === uniquecode) {
                            value["online"] = false;
                            return value
                        }
                        return value;
                    })
                    firebaseDatabase.ref(`Groups/${uniquekey}/participants/`).onDisconnect().update(updateParticipants);
                    Chat.fetch_ref_on_update(`/Groups/${uniquekey}`, this.FetchGroupData);
                    this.FetchMessageData();
                });
            }
        })
    }

    FetchGroupData = value => {
        let { uniquecode } = AuthHelper.getUserDetail();
        uniquecode = uniquecode ?? currentUser();
        let { participants } = value;
        this.setState({ firebaseParticipants: participants });
    }

    

    FetchMessageData = () => {
        let { uniquekey } = this.props;
        firebaseDatabase.ref("Chat").on("value", (messageshot) => {
            let { _chatOpen } = this.props;
            let { __initiated } = this.state;
            if (messageshot.hasChild(uniquekey)) {
                this.setState({ chat: Object.values(messageshot.child(uniquekey).val()) });
                if (!_chatOpen && __initiated) {
                    let AllMessage = Object.values(messageshot.child(uniquekey).val())
                    let LastMessage = AllMessage[AllMessage.length - 1];
                    this.setState(prevState => {
                        let oldMessage = prevState.__alertMessage;
                        if (oldMessage.length >= 5) {
                            oldMessage.splice(-1);
                        }
                        return { __alertMessage: [LastMessage, ...oldMessage] }
                    }, () => {
                        const { __alertMessage } = this.state;
                        const LastDate = LastMessage.date;
                        setTimeout(() => {
                            this.setState({ __alertMessage: __alertMessage.filter(value => value.date !== LastDate) });
                        }, 5000)
                    });
                }
            };
            if (!__initiated) {
                this.setState({ __initiated: true });
            }
        });
    }

    componentDidUpdate(prevProps) {
        const { _chatOpen: old_chatOpen } = prevProps;
        const { _chatOpen } = this.props;
        if (old_chatOpen !== _chatOpen && _chatOpen) {
            this.setState({ __alertMessage: [] });
        }
    }

    handleSend = () => { 
        const { message, isPrivate, chatWith, chatFrom, _FilePath: media,type } = this.state; 
        console.log("====>isPrivate===>",isPrivate)
        const { uniquekey } = this.props;
        let { uniquecode, firstname, lastname, app_picture: profile } = AuthHelper.getUserDetail();
        uniquecode = uniquecode ?? currentUser();
        if (message || media) {
            let dataToSend = { chatFrom, chatWith, date: firebaseApp.database.ServerValue.TIMESTAMP, from: uniquecode, from_name: `${firstname} ${lastname}`, isPrivate, media, message, type:message?"text":type, profile:profile??"" };
            console.log("================>dataToSend===>",dataToSend)
            firebaseDatabase.ref("Chat").child(uniquekey).push(dataToSend);
            let __GrpExists = Chat.fetch_if_ref_exists(`/Groups/${uniquekey}/`, true);
            __GrpExists.then(response => {
                if (Object.keys(response).length > 0) {
                    firebaseDatabase.ref("Groups").child(uniquekey).update({ ...response, last_message: message, last_message_time: firebaseApp.database.ServerValue.TIMESTAMP, last_message_type: "text" });
                    this.setState({ message: "" ,_FilePath:"",type:"",isScreenShot:false});
                }
            });

        }
    };

    onKeyPress = (e) => {
        if (e.key === "Enter") {
            this.handleSend();
        }
    };

    selectfileHandler = (event) => {
        if (event.target.files && event.target.files[0]) {
            const selectedFile = event.target.files[0];
            this.setState({ selectedFile }, () => this.onChooseFile());
        }
    };

    onChooseFile = () => {
        const { selectedFile } = this.state;
        if (selectedFile) {
            const prefixFiletype = selectedFile.type.toString(); 
            if (prefixFiletype.includes("image") || prefixFiletype.includes("video") || prefixFiletype.includes("application") || prefixFiletype.includes("audio") || prefixFiletype.includes("text")) {
                let type = prefixFiletype.includes("image") ? "image" : prefixFiletype.includes("video") ? "video" : prefixFiletype.includes("audio") ? "audio" : "textfile";
                this.setState({ type }, () => this.uploadfile());
            }
        }
    };

    uploadfile = async () => {
        const { selectedFile,type } = this.state; 
        const fileSize = selectedFile && selectedFile.size / 1024 / 1024;  // in MiB 
        if (fileSize > 5) {
            swal({
                icon:'warning', 
                text: `Failed to upload ${type}. The ${type} file size is too large.`, 
                button: "Ok" 
            }) 
        } else {
            let response = await APP.store.dispatch(UploadFiles(selectedFile, 'chat'))
            if (response.code === 1) {
                this.setState({
                    _FilePath: response.file_path
                })
            }
        } 
    };

    // DRAG AND DROP functionality

    dragOver = (e) => { 
        e.preventDefault();
    };

    dragEnter = (e) => { 
        e.preventDefault();
    };

    dragLeave = (e) => { 
        e.preventDefault();
    };
    
    fileDrop = (e) => {  
        e.preventDefault();
        const files = e.dataTransfer.files;
        this.setState(
            {
                selectedFile: files[0],
            },
            () => {
                this.onChooseFile();
            }
        );
    }; 

    ChatHandler = (e) => {
        if (e.target.value === "public") {
            this.setState({ isPrivate: false, chatWith: "public", chatFrom: "" });
        } else {
            let { uniquecode } = AuthHelper.getUserDetail();
            uniquecode = uniquecode ?? currentUser();
            this.setState({ isPrivate: true, chatWith: e.target.value, chatFrom: uniquecode });
        }
    }; 
    
    handleClose = (response) => {
        const { __alertMessage } = this.state;
        this.setState({ __alertMessage: __alertMessage.filter(value => value.date !== response.date) })
    }

    handlePaste = (e) => {
        if (e.clipboardData.files.length) {
            const fileObject = e.clipboardData.files[0];  
            const reader = new FileReader();
            reader.addEventListener("load", () =>
                this.setState({ 
                    src: reader.result 
                },()=>{
                    const {src} = this.state
                    let base64UrlToImage = dataURLtoFile(src,"screenshot.png"); 
                    this.setState({
                        selectedFile:base64UrlToImage,
                        isScreenShot:true
                    },()=>this.onChooseFile()) 
                })
            );
            reader.readAsDataURL(fileObject); 
        //   const filesState = this.state.files.map((f) => ({ ...f }));
        //   filesState.push(file); 
        //   this.setState({ files: filesState });
        } 
      };

    render() {  
        const {previewImage,_FilePath, chat, message, chatWith, firebaseParticipants, __alertMessage,selectedFile,isScreenShot,previewModal } = this.state; 
        const {meeting_details: { topic }, } = this.props;
        let { uniquecode } = AuthHelper.getUserDetail();
        uniquecode = uniquecode ?? currentUser();   
        return (
            <>
                <MessageAlert message={__alertMessage} handleClose={this.handleClose} />
                <div className={`right-part-video-meet d-none right-chat-1`}>
                    <div className={`video-chat`}> 
                        <div className="open-chat ">
                            <div className="open-chat22 d-flex justify-content-between flex-column">
                                <div className="d-flex chat-profile p-2 chat-tool-header justify-content-between">
                                    <div className="d-flex">
                                        <div className="chat-pro-name">
                                            <div className="chat-pro-name-inner">
                                                <h5 className="chat-name mb-0">
                                                    {topic}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="close-chat">
                                        <a href={void 0} onClick={ToggleChat}>
                                            <i className="fas fa-times"></i>
                                        </a>
                                    </div>
                                </div>
                                <div
                                    className=" mid-sec"
                                    ref={(input) => {
                                        this.messagesEnd = input;
                                    }}
                                    onDragOver={this.dragOver}
                                    onDragEnter={this.dragEnter}                                                          
                                    onDragLeave={this.dragLeave}
                                >
                                    {chat instanceof Array &&
                                        chat.map((values, keys) => {
                                            let time = values.time;
                                            if (values.isPrivate && ![values.chatWith, values.chatFrom].includes(uniquecode)) {
                                                return null;
                                            } 
                                            return (
                                                <div
                                                    className={`w-100 float-${uniquecode === values.from ? "right" : "left"}`}
                                                    key={`messages_${keys}`}
                                                >
                                                    <div
                                                        className={`msg-inbox ${uniquecode === values.from ? "send" : "recive"}`}
                                                    > 
                                                        <div
                                                            className={`chats-text  ${uniquecode === values.from  && values.type !== "text" ? "sender-image-div" : uniquecode !== values.from  && values.type !== "text" ? "recever-image-div text-left" :""}  ${uniquecode === values.from  && values.type === "text" ? "bg-orange" : ""} ${values.type === "audio" ? "audio-div" : ""}  ${uniquecode !== values.from  && values.type === "text" ? "text-left" : ""} `}
                                                        >
                                                            {values.type === "text" ? (
                                                                <p className="m-0 chat-font">
                                                                    {values.message}
                                                                </p>
                                                            ) : values.type === "image" ? (
                                                                <img 
                                                                    src={values.media} 
                                                                    className="msg-img-video cursor-zoom-in" 
                                                                    style={{ width: "172px" }} 
                                                                    onClick={()=>this.setState({
                                                                        previewModal:true,
                                                                        previewImage:values.media
                                                                    },()=>ToggleChat())}
                                                                />
                                                            ) : values.type === "video" ? (
                                                                <video 
                                                                    controls src={`${values.media}`} 
                                                                    className="msg-img-video" 
                                                                    style={{ width: "172px" }}>
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            ) : values.type === "audio" ? (
                                                                <audio 
                                                                    controls 
                                                                    className="audio-custom"
                                                                >
                                                                    <source src={values.media} />
                                                                    Your browser does not support the audio element.
                                                                </audio>
                                                            ) : values.type === "file" ? (
                                                                <>
                                                                    {values.media.includes(".pdf") === true ? (
                                                                        <a 
                                                                            href={values.media} 
                                                                            type="application/pdf" 
                                                                            download target="_blank"
                                                                        >
                                                                            <i className="fa fa-file-pdf file-size-and-color"></i>
                                                                        </a>
                                                                    ) : values.media.includes(".zip") ? (
                                                                        <a 
                                                                            href={values.media}
                                                                        >
                                                                            <i className="fa fa-file-archive file-size-and-color" ></i>
                                                                        </a>
                                                                    ) : null}
                                                                </>

                                                            ) : values.type === "textfile" ?
                                                                <a 
                                                                    href={values.media} 
                                                                    download 
                                                                    target="_blank"
                                                                >
                                                                    <i className="fas fa-file-alt file-size-and-color"></i>
                                                                </a>
                                                                : null}
                                                        </div>
                                                        <div className="chat-time text-right">
                                                            <p
                                                                className={`text-black ${uniquecode === values.from ? "" : "float-left"}`}
                                                            >
                                                                <small>{`${moment(time) .locale("en").format("lll")}`}<br/>
                                                                    {`(${values.from_name ?? "Unknown" })`} 
                                                                </small>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                                <div class="form-group d-flex msg-input chat-tool-footer-2 ">
                                    <span className="to-span">To</span>
                                    <select
                                        className="form-control"
                                        onChange={this.ChatHandler}
                                        value={chatWith}
                                    >
                                        <option value="public">Everyone</option>
                                        {firebaseParticipants instanceof Array &&
                                            firebaseParticipants.map((value) => {
                                                if (value.uniquecode === uniquecode) {
                                                    return null;
                                                }
                                                return (
                                                    <option
                                                        key={value.uniquecode}
                                                        value={value.uniquecode}
                                                    >
                                                        {value.name}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>  
                                <div className="form-group msg-input chat-tool-footer p-2 m-0 paperclip" onPaste={this.handlePaste}>
                                    <div className="btn-file btn">
                                        <i
                                            className="fas fa-paperclip"
                                            onClick={(e) => this.file.click()}
                                        />
                                        
                                        <input
                                            type="file"
                                            className="hide"
                                            ref={(input) => {
                                                this.file = input;
                                            }}
                                            onChange={this.selectfileHandler}
                                        />
                                       
                                    </div>
                                    <span className={`chat-input-span-sidebar ${isScreenShot ? "chat-input-img" : ""}`} >
                                        {!_FilePath && 
                                            <input
                                                type="text"
                                                className="form-control chat-input"
                                                name="message"
                                                value={message}
                                                style={{ textAlign: "left" }}
                                                placeholder="Type something here..."
                                                onChange={(e) =>
                                                    this.setState({
                                                        message: e.target.value,
                                                    })
                                                }
                                                onKeyPress={this.onKeyPress}
                                                onDrop={this.fileDrop}
                                            />
                                        }
                                        {_FilePath &&  !isScreenShot && 
                                             <div className="doc-file-div" onKeyPress={this.onKeyPress}> 
                                                <img src="public/assets/images/notes.png" alt="view"/>
                                                <p >{selectedFile?.name??""}</p>
                                                <a href={void 0} onClick={()=>this.setState({_FilePath:""})}>
                                                    <i className="fas fa-times"></i>
                                                </a>
                                            </div> 
                                        } 
                                        {_FilePath &&  isScreenShot && 
                                             <div className="upload-img-div" onKeyPress={this.onKeyPress}> 
                                                <img src={_FilePath} alt="view"/> 
                                                <a href={void 0} onClick={()=>this.setState({_FilePath:"",isScreenShot:false})}>
                                                    <i className="fas fa-times"></i>
                                                </a>
                                            </div> 
                                        }                                                                      

                                    </span>
                                    <a
                                        href={void 0}
                                        className="paper-plane"
                                        onClick={()=>this.handleSend()}

                                    >
                                        <i className="fas fa-paper-plane"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Loader />

                {previewModal && 
                    <PreviewModal  
                        open={previewModal} 
                        handleClose={()=>this.setState({previewModal:false},()=>removeBackdrop())} 
                        file_src={previewImage}
                    />
                }
            </>
        );
    }
    
}
const mapStateToProps = (state) => {
    return {
        meeting_details: state["features/nxatel_meet"].meeting_details,
        _participants: state["features/base/participants"],
    };
};
export default connect(mapStateToProps)(FireChat);
